<template>
  <div class="frequency-buttons">
    <mds-button variation="flat" @click="$emit('close')">
      {{ translate('frequency.modal.cancel.button') }}
    </mds-button>
    <mds-button
      variation="primary"
      :disabled="disableSaveButton"
      @click="$emit('save-schedule')"
    >
      {{ saveButtonName }}
    </mds-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MdsButton } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/frequencyModal/config/i18n'

export default {
  name: 'FrequencyModalButtons',
  components: {
    MdsButton,
  },
  props: {
    disableSaveButton: Boolean,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    ...mapState({
      editedSchedule: (state) => state.cache.cache.editedSchedule,
    }),
    saveButtonName() {
      return this.editedSchedule
        ? this.translate('frequency.modal.edit.button')
        : this.translate('frequency.modal.save.button')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';
.frequency-buttons {
  display: flex;
  justify-content: space-between;
}
</style>
